<template>
  <div>
    <el-dialog
      title="Review Request"
      :visible="dialog_review"
      width="500px"
      top="3vh"
      :modal="true"
      @close="closeDialog()"
    >
      <p>Requested action:
        <el-tag v-if="selectedRequest.status === 2" type="success">
          Insert
        </el-tag>
        <el-tag v-else-if="selectedRequest.status === 3" type="danger">
          Delete
        </el-tag>
      </p>
      <p v-if="selectedRequest.requester">
        Requested by: <br>
        Name: <strong>{{selectedRequest.requester.first_name}} {{selectedRequest.requester.surname}}</strong> <br>
        Email: <strong>{{selectedRequest.requester.email}}</strong>
      </p>
      <p>Channel info:</p>
      <div class="flex-center">
        <img :src="selectedRequest.image_url" class="profile-photo">
      </div>
      <p>Channel title: <strong>{{selectedRequest.title}}</strong><br>
        Channel ID: <strong>{{selectedRequest.channelId}}</strong></p>
      <p>Reason:<br>
      <strong v-if="selectedRequest.status === 2">{{selectedRequest.reason_for_add_request}}</strong>
      <strong v-else-if="selectedRequest.status === 3">{{selectedRequest.reason_for_delete_request}}</strong>
      </p>
      <el-form label-position="top">
        <el-form-item label="Rejection Reason" prop="reason">
          <el-input type="textarea" v-model="reason" rows="4" :class="{errorinput: showReasonError}" />
          <el-descriptions-item :class="{errortext: showReasonError}">To reject request, you must state a reason.</el-descriptions-item>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="approve"
        >
          Approve
        </el-button>
        <el-button
            type="default"
            size="mini"
            :loading="loading"
            @click="reject()"
        >
          Reject
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      reason: '',
      showReasonError: false
    }
  },
  computed: {
    ...mapState('youtubeWhitelist', ['dialog_review', "selectedRequest", 'loading'])
  },

  methods: {
    ...mapActions('youtubeWhitelist', ['rejectDelete', 'rejectInsert', "approveDelete", "approveInsert"]),
    ...mapMutations('youtubeWhitelist', ['setDialogReview', "setSelectedRequest"]),

    approve() {
      if (this.selectedRequest.status === 2) {
        this.approveInsert([this.selectedRequest.channelId])
      } else if (this.selectedRequest.status === 3) {
        this.approveDelete(this.selectedRequest.channelId)
      }
      this.closeDialog();
    },
    reject() {
      if (this.reason === '') {
        this.showReasonError = true;
      } else {
        this.$confirm(
            'You will reject this user request. Continue?',
            'Warning',
            {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }
        )
            .then(() => {
              const payload = {
                ids: [this.selectedRequest.channelId],
                reason: this.reason
              }
              if (this.selectedRequest.status === 2) {
                this.rejectInsert(payload)
              } else if (this.selectedRequest.status === 3) {
                this.rejectDelete(payload)
              }
              this.showReasonError = false;
              this.setDialogReview(false)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: 'Delete cancelled'
              })
            })
      }
    },
    closeDialog() {
      this.setDialogReview(false)
      this.setSelectedRequest({})
      this.showReasonError = false;
      this.reason = ''
    }
  }
}
</script>
<style scoped>
.profile-photo {
  border-radius: 100%;
}

.errorinput >>> .el-textarea__inner {
  border-color: #d3162f;
}
.errortext{
  color: #d3162f;
}
</style>
